import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout.jsx'
import ProtectedRoute from './components/ProtectedRoute.jsx'
import LoginPage from './pages/LoginPage.jsx'
import DashboardPage from './pages/DashboardPage.jsx'
import MembersPage from './pages/MembersPage.jsx'
import MemberDetailPage from './pages/MemberDetailPage.jsx'
import PlansPage from './pages/PlansPage.jsx'
import SchedulePage from './pages/SchedulePage.jsx'
import GatePage from './pages/GatePage.jsx'
import ReportsPage from './pages/ReportsPage.jsx'
import BillingPage from './pages/BillingPage.jsx'
import AppointmentsPage from './pages/AppointmentsPage.jsx'
import StaffPage from './pages/StaffPage.jsx'
import POSPage from './pages/POSPage.jsx'
import LeadsPage from './pages/LeadsPage.jsx'
import WaiversPage from './pages/WaiversPage.jsx'

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<LoginPage />} />

      {/* Root redirect */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* Protected — wrapped in Layout */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/members" element={<MembersPage />} />
        <Route path="/members/:id" element={<MemberDetailPage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/gate" element={<GatePage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/appointments" element={<AppointmentsPage />} />
        <Route path="/pos" element={<POSPage />} />
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/waivers" element={<WaiversPage />} />
        <Route path="/staff" element={<StaffPage />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}
